import { StyleSheet } from 'react-native';
import type { Theme } from '../../../src/theme/getTheme';
import { MODAL_SCRIM_RGBA } from '../../../src/theme/modalOverlay.constants';

export const CHEST_ART_SIZE = 96;

export const getChestCelebrationModalStyles = (theme: Theme) =>
  StyleSheet.create({
    backdrop: {
      flex: 1,
      backgroundColor: MODAL_SCRIM_RGBA,
      justifyContent: 'center',
      alignItems: 'center',
      padding: 24,
    },
    card: {
      width: '100%',
      maxWidth: 340,
      borderRadius: 20,
      backgroundColor: theme.background.card,
      paddingVertical: 24,
      paddingHorizontal: 20,
      alignItems: 'center',
      gap: 8,
      shadowColor: theme.shadow,
      shadowOpacity: 0.5,
      shadowRadius: 16,
      shadowOffset: { width: 0, height: 8 },
      elevation: 8,
    },
    art: {
      width: CHEST_ART_SIZE,
      height: CHEST_ART_SIZE,
      marginBottom: 6,
    },
    title: {
      fontSize: theme.typography.h2.fontSize,
      fontWeight: '800',
      color: theme.white,
      textAlign: 'center',
    },
    coins: {
      fontSize: 28,
      fontWeight: '800',
      color: theme.accent,
      fontVariant: ['tabular-nums'],
      textAlign: 'center',
    },
    subtitle: {
      fontSize: theme.typography.bodySmall.fontSize,
      color: theme.gray[500],
      textAlign: 'center',
    },
    button: {
      marginTop: 12,
      alignSelf: 'stretch',
      height: 44,
      borderRadius: theme.borderRadius.md,
      backgroundColor: theme.primary,
      justifyContent: 'center',
      alignItems: 'center',
    },
    buttonPressed: {
      opacity: 0.85,
    },
    buttonHover: {
      opacity: 0.92,
    },
    buttonText: {
      fontSize: 15,
      fontWeight: '800',
      color: theme.onPrimary,
    },
  });
